import {
  CreateGuesser as RACreateGuesser,
  CreateGuesserProps as RACreateGuesserProps,
} from '@api-platform/admin';

export const CreateGuesser = RACreateGuesser;

export type CreateGuesserProps = RACreateGuesserProps;
